import React from "react";
import albert from "../img/conferencias/albert.png";
 

const ponentesData = [
  {
    id: 1,
    nombre: "Albert Sangrà",
    
    contenido:
      "Albert Sangrà es experto en e-learning y catedrático de Educación en la UOC. Lleva 30 años dedicado a la investigación y la docencia en el ámbito del aprendizaje en línea, y fue uno de los miembros fundadores del equipo de la Universitat Oberta de Catalunya (UOC). Es director de la Cátedra UNESCO de Educación y Tecnología para el Cambio Social y ha recibido varios premios por su labor. Su interés por el uso de las tecnologías en la educación, y en particular en la educación a distancia o en línea, se refleja en sus publicaciones y proyectos. Es consultor y asesor en proyectos para la implementación y el desarrollo de modelos de educación digital.",
      foto: albert,
  } ,
];

export default function Conferencias() {
  return (
    <section className="bg-[#004270] py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Título de la sección */}
        <div className="text-center mb-12">
          <p className="inline-flex items-center px-3 py-1 text-xs mb-6 font-medium text-[#004270] bg-amber-100 rounded-full dark:bg-indigo-950 dark:text-indigo-300">
          Conferencias 
          </p>
          <h2 className="text-white">Conferencias magistrales</h2>
          <p className="text-white">Descubre el futuro de la educación superior y en línea de la mano de grandes expertos.</p>
         
        </div>

        {/* Grid de Tarjetas */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {ponentesData.map((ponente) => (
            <div
              key={ponente.id}
              className="flex flex-col bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 border border-gray-100"
            >
              {/* Contenedor de Foto */}
              <div className="relative h-[450px] w-full bg-gray-200">
                <img
                  src={ponente.foto}
                  alt={ponente.nombre}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Contenido de la Tarjeta */}
              <div className="flex-1 p-6 flex flex-col justify-between">
                <div>
                  <h3>{ponente.nombre}</h3>
                  <p className="text-sm font-semibold text-slate-600 mt-1 mb-4">
                    {ponente.titulo}
                  </p>
                  <p>{ponente.contenido}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
